"use client";
/**
 * Sidebar top-up entry (signed-in only): the photo-maze quota in MAZES (hidden
 * tokens) + a "Top up" button that opens the shared <BuyTokensWidget>
 * (GamesTopUpWidget, mounted in the locale layout). Quota re-reads on purchase
 * / focus via useMazeImageQuota.
 */
import { useTranslations } from "next-intl";
import { Gift } from "lucide-react";
import { openBuyTokens } from "@owlcat/app-shell";
import { APP_ID } from "@/lib/appConfig";
import { useMazeImageQuota } from "@/contexts/subscriptions/hooks/useMazeImageQuota";

export function GamesTopUpPill() {
  const t = useTranslations();
  const { remaining } = useMazeImageQuota();
  if (remaining === undefined || remaining === null) return null;
  return (
    <div
      data-testid="sidebar-topup"
      className="flex items-center justify-between gap-2 rounded-xl border border-border bg-muted/40 px-3 py-2"
    >
      <div className="flex min-w-0 items-center gap-2">
        <Gift className={`h-4 w-4 shrink-0 ${remaining === 0 ? "text-destructive" : "text-amber-500"}`} />
        <div className={`min-w-0 text-xs font-semibold leading-tight ${remaining === 0 ? "text-destructive" : "text-foreground"}`}>
          {t("games.maze.packMazes", { count: remaining })}
        </div>
      </div>
      <button
        type="button"
        onClick={() => openBuyTokens(APP_ID)}
        data-testid="sidebar-topup-button"
        className="shrink-0 rounded-lg bg-primary px-2.5 py-1.5 text-xs font-semibold text-primary-foreground shadow-xs transition-colors hover:bg-primary/90"
      >
        {t("nav.topUp")}
      </button>
    </div>
  );
}
